import { FunctionComponent } from 'react';
import { StudyDescriptionOriginal } from './Original';
import { Variant1 } from './Variant1';
import { Variant2 } from './Variant2';
import { Variant3 } from './Variant3';

export const Variants: Record<string, FunctionComponent<any>> = {
  original: StudyDescriptionOriginal,
  variant1: Variant1,
  variant2: Variant2,
  variant3: Variant3,
};
